import type { HairSalonReservation, HairSalonScheduledTask, UnscheduledHairSalonTask } from '@monorepo/functions/src/types/reservations'

export type CalendarView = 'day' | 'week'

export interface CalendarSlot {
    time: string
    date: string
    isAvailable: boolean
    tasks?: HairSalonScheduledTask[]
}

export type DraggedItem = {
    type: 'reservation' | 'task'
    item: HairSalonReservation | HairSalonScheduledTask
    sourceDate?: string
    sourceTime?: string
}

export interface CalendarState {
    view: CalendarView
    selectedDate: Date
    draggedTask: DraggedItem | null
    unscheduledTasks: UnscheduledHairSalonTask[]
    scheduledTasks: HairSalonScheduledTask[]
    selectedTask: HairSalonScheduledTask | UnscheduledHairSalonTask | null
    isTouchMode: boolean
    isLoading: boolean
}

export interface CalendarActions {
    setView: (view: CalendarView) => void
    setSelectedDate: (date: Date) => void
    setDraggedItem: (item: DraggedItem | null) => void
    setSelectedTask: (task: HairSalonScheduledTask | UnscheduledHairSalonTask | null) => void
    setSelectedReservation: (reservation: HairSalonReservation | null) => void
    setIsTouchMode: (isTouchMode: boolean) => void
    createTasksFromReservation: (reservation: HairSalonReservation, date: string, time: string) => Promise<void>
    updateTask: (task: HairSalonScheduledTask) => Promise<void>
    deleteTask: (taskId: string) => Promise<void>
    getTasksByReservation: (reservationId: string) => HairSalonScheduledTask[]
    getTasksForTimeSlot: (date: string, time: string) => HairSalonScheduledTask[]
}

export interface TimeSlot {
    hour: number
    minute: number
    formatted: string
}

export const BUSINESS_HOURS = {
    start: 8,
    end: 19,
}
